<template>
  <div>
    <page-header :title="$t('dictionary.notice')" />
    <page-body>
      <list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import List from './components/List'

export default {
  name: 'NoticeIndex',
  components: {
    List,
  },
  data () {
    return {
      listId: 'NoticeList',
    }
  },
}
</script>
